import { render, staticRenderFns } from "./indexEmbarazosAnterioresShow.vue?vue&type=template&id=7d33fae3"
import script from "./indexEmbarazosAnterioresShow.vue?vue&type=script&lang=js"
export * from "./indexEmbarazosAnterioresShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports